<template>
  <div
    :data-testid="dataTestid"
    class="border-1 border-semantic-outline-variant bg-semantic-surface-container-lowest px-4 py-[1.125rem] md:p-6 rounded-2md md:rounded-2xl flex flex-col gap-2 md:gap-4 items-start"
  >
    <div class="w-full flex justify-between flex-wrap gap-4 min-h-6">
      <p class="text-base-font-size-xs">
        Updated

        <strong>
          {{ formatDate(new Date(props.date), null, 'DD MMMM YYYY') }}
        </strong>
      </p>

      <div class="flex gap-2">
        <V2AtomsTag
          v-for="tag in filteredTags"
          :key="tag.name"
          color="whiteb"
          class="!text-xs"
        >
          {{ tag.name }}
        </V2AtomsTag>
      </div>
    </div>

    <div class="w-full flex flex-col md:flex-row gap-2 md:gap-8 border-t-1 border-t-semantic-outline-variant pt-2 md:border-t-0 md:pt-0">
      <V2MoleculesAuthorDetailsPopoverCard
        v-if="!_isEmpty(author)"
        :author="author"
        label="Written by"
      />

      <template v-if="!_isEmpty(editor)">
        <div class="w-[0.0625rem] h-inherit bg-semantic-outline-variant"></div>

        <V2MoleculesAuthorDetailsPopoverCard
          :author="editor"
          label="Edited by"
        />
      </template>
    </div>

    <NuxtLink
      to="/editorial-policy/"
      class="text-sm font-semibold text-semantic-primary-default underline"
    >
      Our editorial process
    </NuxtLink>

    <div
      v-if="isFactChecked"
      class="w-full flex items-start pt-2 md:pt-4 border-t-1 border-t-semantic-outline-variant"
    >
      <V2MoleculesPopover
        type="info"
        size="large"
        class="relative"
        theme="card"
        init-pos-x="left"
        init-pos-y="bottom"
        :bottom-offset="0"
        :top-offset="0"
        popover-class="pt-3"
      >
        <div
          class="border-1 border-semantic-outline-variant bg-semantic-surface-default p-2 flex gap-2 rounded-2md text-sm font-semibold hover:bg-semantic-surface-container-low hover:border-semantic-primary-default hover:cursor-pointer"
        >
          <V2IconsCheck class="inline-block wh-5" />

          Fact-Checked

          <V2IconsInfoCircle
            class="inline-block wh-5"
            :fill="semanticColorLookup('primary.default')"
          />
        </div>

        <template #content>
          <div class="flex flex-col items-start gap-2 md:gap-4 text-semantic-sizing-body-sm text-semantic-surface-on-surface">
            <div class="wh-10 rounded-full flex items-center justify-center bg-semantic-inverse-surface-light">
              <V2IconsShieldCheck
                class="wh-6"
                :fill="semanticColorLookup('inverse.primary')"
              />
            </div>

            <div class="w-full text-semantic-sizing-headline-sm text-semantic-surface-on-surface font-semibold">
              Fact-checked by our editorial team

              <p class="text-semantic-sizing-label-lg text-semantic-surface-on-surface-variant mt-1">
                Independent, human, and reviewed before publish
              </p>
            </div>

            Every guide is reviewed by our editorial team - we verify the facts, vet the sources, and update the page whenever products, rates, or rules change. Always double-check the details that matter to your situation before signing up.

            <V2AtomsButton
              to="/editorial-policy/"
              type="primary"
              size="small"
              has-icon-right
            >
              How we fact check
            </V2AtomsButton>
          </div>
        </template>
      </V2MoleculesPopover>
    </div>
  </div>
</template>

<script setup>
import _isEmpty from 'underscore/cjs/isEmpty.js'

defineOptions({
  name: 'MoleculesAuthorBioBox'
})

const props = defineProps({
  dataTestid: {
    type: String,
    default: 'AuthorBioBox'
  },

  author: {
    type: Object,
    default: () => ({})
  },

  editor: {
    type: Object,
    default: () => ({})
  },

  date: {
    type: String,
    default: ''
  },

  tags: {
    type: Array,
    default: () => []
  }
})

const filteredTags = computed(() => props.tags.filter(tag => tag.name !== 'Fact Checked'))

const isFactChecked = computed(() => props.tags.some(tag => tag.name === 'Fact Checked'))
</script>
